"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg")),
    _lodash = _interopRequireDefault(require("lodash.isequal")),
    _lodash2 = _interopRequireDefault(require("lodash.throttle")),
    _icon = require("../styles/icon"),
    _onEnterPressed = _interopRequireDefault(require("../../../common/utils/onEnterPressed")),
    _ToolTip = _interopRequireDefault(require("../../ToolTip")),
    _requiresStroke = _interopRequireDefault(require("../constants/requiresStroke")),
    _ignoresColour = _interopRequireDefault(require("../constants/ignoresColour")),
    _getIcons = _interopRequireDefault(require("./getIcons"));

require("../styles/_icon.scss");

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

function getClickableProps(a) {
  return a.onClick ? {
    onClick: a.onClick,
    tabIndex: 0,
    role: "button",
    onKeyDown: (0, _onEnterPressed["default"])({
      onClick: a.onClick
    })
  } : {
    tabIndex: a.tooltipId && a.tooltipLabel ? 0 : -1
  };
}

var Icon = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.onIconHover = (0, _lodash2["default"])(function () {
      var a = d.props.hoverColor,
          b = d.state.iconColor;
      a && b !== a && d.setState({
        iconColor: a
      });
    }, 200, {
      trailing: !1
    }), d.onIconUnhover = (0, _lodash2["default"])(function () {
      var a = d.state.iconColor,
          b = d.props,
          c = b.color,
          e = b.hoverColor;
      e && a !== c && d.setState({
        iconColor: void 0
      });
    }, 200, {
      trailing: !1
    }), d.state = {
      iconColor: void 0
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(a, b) {
      return !(0, _lodash["default"])(this.props, a) || !(0, _lodash["default"])(this.state, b);
    }
  }, {
    key: "render",
    value: function render() {
      var a,
          b = this.props,
          c = b.name,
          d = b.className,
          e = b.onClick,
          f = b.size,
          g = b.color,
          h = b.spin,
          i = b.hoverColor,
          j = b.tooltipId,
          k = b.tooltipLabel,
          l = b.tooltipPlace,
          m = b.tooltipClass,
          n = b.animated;
      if (!_getIcons["default"][c]) return null;
      var o = _requiresStroke["default"][c],
          p = _ignoresColour["default"][c];
      return _react["default"].createElement(_ToolTip["default"], {
        id: j,
        label: k,
        place: l,
        className: m
      }, _react["default"].createElement("div", (0, _extends2["default"])({
        className: (0, _classnames["default"])("icon-container", (0, _icon.ICON_CONTAINER)({
          size: f,
          hoverColor: i,
          ignoresColour: p,
          requiresStroke: o
        }), (a = {
          "icon-container--animated": n
        }, (0, _defineProperty2["default"])(a, _icon.CLICKABLE, e), (0, _defineProperty2["default"])(a, "spin", h), a), d)
      }, getClickableProps(this.props), {
        onMouseEnter: this.onIconHover,
        onMouseLeave: this.onIconUnhover,
        onFocus: this.onIconHover,
        onBlur: this.onIconUnhover
      }), _react["default"].createElement(_reactInlinesvg["default"], {
        src: _getIcons["default"][c],
        className: (0, _classnames["default"])((0, _icon.ICON_SVG)({
          color: g,
          requiresStroke: o,
          ignoresColour: p,
          size: f
        }), "icon", "icon-".concat(c)),
        uniquifyIDs: !0,
        title: " "
      })));
    }
  }]), b;
}(_react.Component);

exports["default"] = Icon, Icon.displayName = "Icon", Icon.defaultProps = {
  className: void 0,
  onClick: void 0,
  size: 25,
  color: "denim"
};